import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, BookmarkIcon, BellIcon, UserIcon, BriefcaseIcon } from 'lucide-react';
const Navigation: React.FC = () => {
  return <nav className="fixed bottom-0 w-full bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg rounded-t-xl z-50" data-id="element-26">
      <div className="flex justify-around items-center h-16" data-id="element-27">
        <NavLink to="/jobs" className={({
        isActive
      }) => `flex flex-col items-center p-2 rounded-lg transition-colors ${isActive ? 'text-teal-500 dark:text-teal-400' : 'text-gray-500 dark:text-gray-400 hover:text-teal-500 dark:hover:text-teal-400'}`} data-id="element-28">
          <HomeIcon size={20} data-id="element-29" />
          <span className="text-xs mt-1" data-id="element-30">Home</span>
        </NavLink>
        <NavLink to="/saved" className={({
        isActive
      }) => `flex flex-col items-center p-2 rounded-lg transition-colors ${isActive ? 'text-teal-500 dark:text-teal-400' : 'text-gray-500 dark:text-gray-400 hover:text-teal-500 dark:hover:text-teal-400'}`} data-id="element-31">
          <BookmarkIcon size={20} data-id="element-32" />
          <span className="text-xs mt-1" data-id="element-33">Saved</span>
        </NavLink>
        <NavLink to="/jobs" className="flex flex-col items-center" data-id="element-34">
          <div className="bg-gradient-to-r from-teal-500 to-cyan-400 p-3 rounded-full -mt-6 shadow-lg" data-id="element-35">
            <BriefcaseIcon size={24} className="text-white" data-id="element-36" />
          </div>
          <span className="text-xs mt-1 text-gray-500 dark:text-gray-400" data-id="element-37">
            Jobs
          </span>
        </NavLink>
        <NavLink to="/notifications" className={({
        isActive
      }) => `flex flex-col items-center p-2 rounded-lg transition-colors ${isActive ? 'text-teal-500 dark:text-teal-400' : 'text-gray-500 dark:text-gray-400 hover:text-teal-500 dark:hover:text-teal-400'}`} data-id="element-38">
          <BellIcon size={20} data-id="element-39" />
          <span className="text-xs mt-1" data-id="element-40">Alerts</span>
        </NavLink>
        <NavLink to="/profile" className={({
        isActive
      }) => `flex flex-col items-center p-2 rounded-lg transition-colors ${isActive ? 'text-teal-500 dark:text-teal-400' : 'text-gray-500 dark:text-gray-400 hover:text-teal-500 dark:hover:text-teal-400'}`} data-id="element-41">
          <UserIcon size={20} data-id="element-42" />
          <span className="text-xs mt-1" data-id="element-43">Profile</span>
        </NavLink>
      </div>
    </nav>;
};
export default Navigation;